import Base from './Base';

class Groups extends Base {
    join(id: string, data = null, opts = null) {
        return this.postJSONWithSession<User>(`/groups/${id}`, data, opts);
    }
}

export default Groups;
